import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Avatar,
  Badge,
} from '@mui/material';

import { Link, useNavigate, useLocation } from 'react-router-dom';

import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import { MdOutlineFavorite } from "react-icons/md";
import { FaCrown } from "react-icons/fa";

import { BASE_URL } from './../../Api/ApiUrls';
import Userimage from '../Dashboard/Images/Userimage.png';


// ============================================================
// COLORS
// ============================================================

const SIDEBAR_BG = '#F8F7F4';
const BLACK_BG = '#202020';
const POST_PROPERTY_BG = '#BA915B';
const ICON_COLOR = '#C0392B';
const TEXT_DARK = '#000000';
const BORDER_COLOR = '#EAE4DB';


// ============================================================
// NAVIGATION ITEMS
// ============================================================

const NAV_ITEMS = [
  {
    label: 'Post Property',
    icon: AddBoxRoundedIcon,
    to: '/post',
    isPostProperty: true,
  },
  {
    label: 'Subscription Plans',
    icon: FaCrown,
    to: '/user-subscription',
  },
  {
    label: 'New Launching',
    icon: DiamondOutlinedIcon,
    to: '/dashboard/new-launching-props',
    // isNew: true, // REMOVED from New Launching
  },
  {
    label: 'Premium Properties',
    icon: RocketLaunchOutlinedIcon,
    to: '/dashboard/premium-props',
    isNew: true, // ADDED to Premium Properties
  },
  {
    label: 'Featured Properties',
    icon: StarBorderRoundedIcon,
    to: '/dashboard/featured-props',
  },
  {
    label: 'Recommend Properties',
    icon: ApartmentRoundedIcon,
    to: '/dashboard/recommended-props ',
  },
];


// ============================================================
// SIDEBAR
// ============================================================

const Dashboard_verticalside = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [userData, setUserData] = useState(null);

  const userId = localStorage.getItem('userId');


  // ==========================================================
  // GET USER DATA
  // ==========================================================

  useEffect(() => {
    if (!userId) return;

    fetch(`${BASE_URL}/users/${userId}/`)
      .then((response) => response.json())
      .then((data) => {
        setUserData(data);
      })
      .catch((error) => {
        console.error('Error fetching user data:', error);
      });
  }, [userId]);


  // ==========================================================
  // SIDEBAR UI
  // ==========================================================

  return (
    <Box
      sx={{
        width: {
          xs: '58px',
          sm: '58px',
          md: '60px',
        },

        minWidth: {
          xs: '58px',
          sm: '58px',
          md: '60px',
        },

        height: 'calc(100vh - 44px)',
        minHeight: 'calc(100vh - 44px)',

        boxSizing: 'border-box',

        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',

        backgroundColor: SIDEBAR_BG,

        overflow: 'hidden',

        margin: 0,
        padding: '0 3px',

        borderRadius: 0,
        boxShadow: 'none',

        flexShrink: 0,
      }}
    >

      {/* ====================================================
          PROFILE - TOP ROUNDED ONLY
          ==================================================== */}

      <Box
        onClick={() => navigate('/work-detail')}
        sx={{
          width: '100%',
          height: '100px',

          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',

          gap: '5px',

          cursor: 'pointer',

          backgroundColor: BLACK_BG,

          borderRadius: '16px 16px 0 0',

          marginRight: 0,

          border: 'none',

          boxShadow: '0 3px 10px rgba(0,0,0,0.18)',

          flexShrink: 0,

          '&:hover': {
            backgroundColor: '#292929',
          },
        }}
      >
        <Avatar
          src={
            userData?.profile
              ? `${BASE_URL}${userData.profile}`
              : Userimage
          }
          sx={{
            width: '38px',
            height: '38px',

            border: '2px solid #8A6A3D',
          }}
        />

        <Typography
          sx={{
            fontSize: '10px',
            fontWeight: 600,
            color: '#FFFFFF',
            lineHeight: 1,
            textAlign: 'center',
          }}
        >
          Profile
        </Typography>
      </Box>


      {/* ====================================================
          POST PROPERTY - BOTTOM ROUNDED ONLY
          ==================================================== */}

      <Box
        component={Link}
        to={NAV_ITEMS[0].to}
        sx={{
          position: 'relative',

          width: '100%',

          minHeight: '100px',

          boxSizing: 'border-box',

          display: 'flex',
          flexDirection: 'column',

          alignItems: 'center',
          justifyContent: 'center',

          gap: '7px',

          textDecoration: 'none',

          backgroundColor: POST_PROPERTY_BG,

          borderRadius: '0 0 16px 16px',

          marginRight: 0,

          marginTop: 0,
          marginBottom: '2px',

          borderBottom: 'none',

          boxShadow: '0 2px 6px rgba(0,0,0,0.12)',

          transition: 'background-color 0.2s ease',

          flexShrink: 0,

          '&:hover': {
            backgroundColor: '#A67D4A',
          },
        }}
      >
        <AddBoxRoundedIcon
          sx={{
            fontSize: '27px',
            color: '#FFFFFF',
          }}
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Typography
            sx={{
              width: '100%',
              fontSize: '10px',
              fontWeight: 500,
              color: '#FFFFFF',
              textAlign: 'center',
              lineHeight: 1.25,
              whiteSpace: 'nowrap',
            }}
          >
            Post
          </Typography>
          <Typography
            sx={{
              width: '100%',
              fontSize: '10px',
              fontWeight: 500,
              color: '#FFFFFF',
              textAlign: 'center',
              lineHeight: 1.25,
              whiteSpace: 'nowrap',
            }}
          >
            Property
          </Typography>
        </Box>
      </Box>

{/* ====================================================
SUBSCRIPTION PLANS - MATCHING WISHLIST CIRCLE UI
==================================================== */}
<Box
  component={Link}
  to={NAV_ITEMS[1].to}
  sx={{
    position: 'relative',
    width: '100%',
    minHeight: '82px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '7px',
    textDecoration: 'none',
    backgroundColor: SIDEBAR_BG,
    borderRadius: '8px',
    marginRight: 0,
    marginTop: 0,
    marginBottom: 0,
    border: '1px solid #000000',
    boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
    transition: 'background-color 0.2s ease',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: 'rgba(138,106,61,0.08)',
    },
  }}
>
  {/* Circular icon container */}
  <Box
    sx={{
      width: 36,
      height: 36,
      borderRadius: '50%',
      background: '#F8F7F4',
      border: '1px solid rgba(138,106,61,0.2)',
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Badge
      badgeContent={NAV_ITEMS[1].badge}
      sx={{
        '& .MuiBadge-badge': {
          backgroundColor: '#E53935',
          color: '#FFFFFF',
          fontSize: '8px',
          fontWeight: 700,
          minWidth: '15px',
          height: '15px',
          padding: 0,
          top: '-2px',
          right: '-5px',
        },
      }}
    >
      {/* ✅ Outline heart, colored via wrapper Box */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: "#8A6A3D",          // <-- '#C0392B'
          fontSize: '27px',
          lineHeight: 1,
        }}
      >
       <FaCrown
  style={{
    color: 'inherit',
    fontSize: '27px',
  }}
/>
      </Box>
    </Badge>
  </Box>

  {/* Label below the circle */}
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
    }}
  >
    <Typography
      sx={{
        width: '100%',
        fontSize: '9px',
        fontWeight: 500,
        color: TEXT_DARK,
        textAlign: 'center',
        lineHeight: 1.25,
        whiteSpace: 'nowrap',
      }}
    >
      Subscription
    </Typography>
    <Typography
      sx={{
        width: '100%',
        fontSize: '9px',
        fontWeight: 500,
        color: TEXT_DARK,
        textAlign: 'center',
        lineHeight: 1.25,
        whiteSpace: 'nowrap',
      }}
    >
      Plans
    </Typography>
  </Box>
</Box>
      {/* ====================================================
          BLACK SECTION - WITH BORDER RADIUS
          ==================================================== */}

      <Box
        sx={{
          width: '100%',
          marginRight: 0,

          backgroundColor: BLACK_BG,

          display: 'flex',
          flexDirection: 'column',

          flexShrink: 0,

          marginTop: '0.2rem',

          borderRadius: '8px',
          overflow: 'hidden',

          boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
        }}
      >
        {NAV_ITEMS.slice(2).map((item) => (
          <NavItem
            key={item.label}
            item={item}
            location={location}
            dark
          />
        ))}
      </Box>


      {/* ====================================================
          REMAINING SPACE
          ==================================================== */}

      <Box
        sx={{
          flex: 1,

          width: '100%',

          backgroundColor: SIDEBAR_BG,

          minHeight: 0,
        }}
      />

    </Box>
  );
};


// ============================================================
// NAV ITEM
// ============================================================

const NavItem = ({
  item,
  location,
  dark = false,
}) => {

  const {
    label,
    icon: Icon,
    to,
    badge,
    isNew,
    isPostProperty,
  } = item;


  // ==========================================================
  // ACTIVE
  // ==========================================================

  const isActive = location.pathname === to;


  const showBrown =
    isPostProperty || isActive;


  // ==========================================================
  // LABEL SPLIT
  // ==========================================================

  let labelParts = [label];


  if (label === 'Post Property') {
    labelParts = ['Post', 'Property'];
  }


  if (label === 'Subscription Plans') {
    labelParts = ['Subscription', 'Plans'];
  }


  if (label === 'New Launching') {
    labelParts = ['New', 'Launching'];
  }


  if (label === 'Premium Properties') {
    labelParts = ['Premium', 'Properties'];
  }


  if (label === 'Featured Properties') {
    labelParts = ['Featured', 'Properties'];
  }


  if (label === 'Recommend Properties') {
    labelParts = ['Recommend', 'Properties'];
  }


  // ==========================================================
  // BACKGROUND
  // ==========================================================

  let backgroundColor;


  if (showBrown) {
    backgroundColor = POST_PROPERTY_BG;
  } else if (dark) {
    backgroundColor = BLACK_BG;
  } else {
    backgroundColor = SIDEBAR_BG;
  }


  // ==========================================================
  // TEXT COLOR
  // ==========================================================

  const textColor =
    showBrown || dark
      ? '#FFFFFF'
      : TEXT_DARK;


  // ==========================================================
  // ICON COLOR
  // ==========================================================

  const iconColor =
    showBrown || dark
      ? '#FFFFFF'
      : ICON_COLOR;


  // ==========================================================
  // NAV ITEM
  // ==========================================================

  return (
    <Box
      component={Link}
      to={to}
      sx={{
        position: 'relative',

        width: '100%',

        minHeight: '82px',

        boxSizing: 'border-box',

        display: 'flex',
        flexDirection: 'column',

        alignItems: 'center',
        justifyContent: 'center',

        gap: '7px',

        textDecoration: 'none',

        backgroundColor,

        borderRadius: '0px',

        marginRight: 0,

        marginTop: 0,
        marginBottom: 0,

        borderBottom: dark
          ? '1px solid rgba(255,255,255,0.12)'
          : `1px solid ${BORDER_COLOR}`,

        boxShadow: 'none',

        transition: 'background-color 0.2s ease',

        flexShrink: 0,

        '&:hover': {
          backgroundColor: showBrown
            ? POST_PROPERTY_BG
            : dark
              ? '#292929'
              : 'rgba(138,106,61,0.08)',
        },
      }}
    >

      {/* ==================================================
          NEW BADGE - Now shows on Premium Properties
          ================================================== */}

      {isNew && (
        <Box
          sx={{
            position: 'absolute',

            top: '5px',
            right: '3px',

            fontSize: '6px',
            fontWeight: 700,

            color: '#FFFFFF',

            backgroundColor: '#D89A32',

            borderRadius: '4px',

            px: '3px',
            py: '2px',

            lineHeight: 1,

            zIndex: 2,
          }}
        >
          NEW
        </Box>
      )}


      {/* ==================================================
          ICON
          ================================================== */}

      <Badge
        badgeContent={badge}
        sx={{
          '& .MuiBadge-badge': {
            backgroundColor: '#E53935',
            color: '#FFFFFF',

            fontSize: '10px',
            fontWeight: 700,

            minWidth: '15px',
            height: '15px',

            padding: 0,

            top: '-2px',
            right: '-5px',
          },
        }}
      >
        <Icon
          sx={{
            fontSize: '27px',
            color: iconColor,
          }}
        />
      </Badge>


      {/* ==================================================
          LABEL
          ================================================== */}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',

          alignItems: 'center',
          justifyContent: 'center',

          width: '100%',
        }}
      >
        {labelParts.map((part, index) => (
          <Typography
            key={index}
            sx={{
              width: '100%',

              fontSize:
                label === 'Recommend Properties'
                  ? '7px'
                  : '8px',

              fontWeight: 500,

              color: textColor,

              textAlign: 'center',

              lineHeight: 1.25,

              whiteSpace: 'nowrap',
            }}
          >
            {part}
          </Typography>
        ))}
      </Box>

    </Box>
  );
};


export default Dashboard_verticalside;